import React from 'react';

const Open247 = ({ color = 'var(--color-primary)' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="20"
    viewBox="0 0 25 20"
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.832 17.568c-4.825 0-8.736-3.911-8.736-8.736C.096 4.007 4.007.096 8.832.096c4.755 0 8.623 3.8 8.734 8.528"
        transform="translate(1 1)"
      />
      <text
        fill={color}
        fontFamily="CircularTT-Bold, Circular TT"
        fontSize="9.6"
        fontWeight="bold"
        letterSpacing=".005"
        transform="translate(1 1)"
      >
        <tspan x="12.587" y="18.367">
          24
        </tspan>
      </text>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M8.832 3.84L8.832 9.024 14.208 9.024"
        transform="translate(1 1)"
      />
    </g>
  </svg>
);

export default Open247;
